export default {
    sysMenu: {
    emailManage: 'Quản lý Email tiếp thị',
    emailAutoPushConfig: 'Cấu hình email tự động',
    bulkEmail: 'Gửi email hàng loạt',
    emailTemp: 'Quản lý mẫu',
    emailSender: 'Quản lý người gửi',
    emailLog: 'Nhật ký gửi',
    emailUnsubscribe: 'Danh sách hủy đăng ký',
    emailSendRecordStats: 'Báo cáo gửi',
    seoPlatform: 'Nền tảng SEO/GEO',
    seoPFDashboard: 'Tổng quan',
    seoPFContentCenter: 'Trung tâm nội dung',
    seoPFArticleManagement: 'Quản lý bài viết',
    seoPFArticleType: 'Danh mục bài viết',
    seoPFArticleTag: 'Thẻ bài viết',
    seoPFManagerTools: 'Công cụ SEO/GEO',
    seoPFKeyWordCenter: 'Trung tâm từ khóa',
    seoPFAICreateContent: 'Tạo nội dung AI',
    seoPFScore: 'Điểm SEO/GEO',
    seoPFSiteConfig: 'Cấu hình trang web',
    seoPFPageModel: 'Mẫu SEO trang',
    seoPFSiteLink: 'Liên kết nội bộ',
    seoPFSiteMapManagement: 'Quản lý Sitemap',
    seoPFDeclDoc: 'Tệp khai báo',
    seoPFHealthCheck: 'Kiểm tra sức khỏe SEO',
    seoPFSiteBaseUrl: 'URL gốc trang H5',
    seoPFAuthor: 'Thư viện tác giả',
    AIModelConfig: 'Cấu hình mô hình AI',
        sysAdsMgmt: 'Quản lý quy kết quảng cáo',
        adsmccaccount: "Cấu hình tài khoản quảng cáo MCC",
        adsaccount: "Cấu hình quy kết quảng cáo",
        adsreport: "Phân tích báo cáo",
        adsuserpushrecord: "Lịch sử đẩy thông báo",
        silentMember: 'Danh sách người dùng không hoạt động',
        adsAgent: "Liên kết quy kết đại lý",
        sys: "Cài đặt hệ thống",
        sms: "Nhà cung cấp dịch vụ SMS",
        smsManage: "Quản lý SMS",
        bulkSMS: "SMS hàng loạt",
        modelSMS: "Mẫu SMS",
        channelSMS: "Kênh tiếp thị SMS",
        taskRegister: "Đăng ký chưa nạp tiền",
        taskSilence: "Người dùng không hoạt động",
        taskOff: "Người dùng rời bỏ",
        welcomeSMS: "SMS chào mừng",
        restorageSMS: "Nạp lại sau lần nạp đầu",
        birthdaySMS: "Nhắc Nhở Sinh Nhật",
        taskVIP: "Nhiệm vụ VIP",
        smsRecordStats: "Báo cáo SMS",
        smsSendRecord: "Nhật ký SMS",
        memberList: "Danh sách thành viên",
        risk: "Kiểm soát rủi ro",
        memberRiskDimensionStats: "Cảnh báo rủi ro đa chiều",
    ipRiskDimensionStats: "Cảnh báo người dùng cùng IP",
    deviceRiskDimensionStats: "Cảnh báo người dùng cùng thiết bị",
    bankRiskDimensionStats: "Cảnh báo người dùng cùng thẻ ngân hàng",
    walletRiskDimensionStats: "Cảnh báo người dùng cùng ví",
        agentDailyPerformance: "Dữ liệu Đại lý Hôm nay",
        financial: "Trung tâm tài chính",
        member: "Trung tâm thành viên",
        operation: "Trung tâm vận hành",
        operationsGroup: "Trung tâm vận hành",
        operationsBackgroundImage: "Quản lý hình nền",
        systemConfig: "Cài đặt menu",
        agentDailyStats: 'Thống kê hiệu suất hàng ngày của đại lý',
        memberChurn: "Danh sách thành viên mất khách hàng",
        inactiveDepositors: 'Danh sách đã đăng ký nhưng chưa nạp tiền',
        agentCostStats:'Chi phí quảng cáo',
        market: "Quản lý thị trường",
        agentMgmt: "Quản lý đại lý",
        agentTransfer: "Chuyển đại lý",
        sysConfigMgmt: "Quản lý cấu hình",
        queryRole: "Quản lý vai trò",
        userMgmt: "Quản lý tài khoản",
        ipWhitelist: "Danh sách IP",
        operationLog: "Nhật ký thao tác",
        lang: "Quản lý ngôn ngữ",
        buttons: "Quản lý nút",
        menus: "Quản lý menu",
        curreny: "Quản lý tiền tệ",
        userAccountMgmt: "Quản lý tài khoản",
        activity: "Hệ thống ưu đãi",
        freeSpinGrant: "Cấp Free Spin",
        gamePlatform: "Quản lý game",
        clientInfo: "Quản lý nội dung",
        vip: "Quản lý VIP",
        mall: "Cửa hàng điểm",
        agentTotalStats:"Thống kê đại lý",
        gamePlatformMgmt: "Cài đặt game",
        gameBRoutePlatform: "Nền tảng tuyến B",
        gameListMgmt: "Cài đặt game con",
        gameEntryMgmt: "Quản lý trang chủ",
        gamePromotMgmt: "Game chính",
        gameHotMgmt: "Trò chơi hấp dẫn",
        gameRecMgmt: "Trò chơi hấp dẫn",
        gameTypeMgmt: "Loại game",
        gameModuleMgmt: "Quản Lý Mô-đun Client",
        desktopGameModuleMgmt: "Quản Lý Mô-đun Ki-ốt",
        activityWelfareMgmt: "Lịch sử nhận",
        activityManualSendMgmt: "Gửi hàng loạt",
    fsBatch: "Phát Free Spin",
        activityMgmt: "Cài đặt ưu đãi",
        activityTypeMgmt: "Loại ưu đãi",
        activityOperateMgmt: "Quản lý ưu đãi đặc biệt",
        activityRedPacket: "Mưa phong bì",
        activityRedPacketMgmt: "Quản lý Mưa phong bì",
        redPacketStats: "Thống kê Mưa phong bì",
        activityRedemptionCodeMgmt: "Quản lý mã đổi thưởng",
        redemptionCodeMgmt: "Quản lý mã đổi thưởng",
        indexBotMenu: "Menu dưới",
        indexLtMenu: "Menu trái",
        indexBanner: "Banner",
        indexContactUs: "Liên hệ",
        indexSpopup: "Popup",
        indexStartAdvertising: "Quảng cáo",
        betRecord:'Lịch sử đặt cược',
        betRecordA:'Lịch sử đặt cược',
        betRecordB:'Lịch sử đặt cược - B',
        manualBalance:'Hồ Sơ Điều Chỉnh Tài Khoản',
        manualBalanceHistory: 'Nhật ký thay đổi hạn mức điều chỉnh',
        memberWithdrawLimit: 'Hạn mức rút tiền hàng ngày của thành viên',
        payWithdrawConfig: "Cấu hình nạp/rút",
        riskWithdrawConfig: "Cài đặt kiểm soát rút tiền",
        riskAuthWithdraw: "Kiểm duyệt rút",
        kyc: "Xác thực KYC",
        kycApply: "Lịch sử KYC",
        kycCBOApply: "Hồ sơ xác minh KYC",
        kycSUP: "Lịch sử KYC đầy đủ",
        blacklistQuery: "Truy vấn danh sách đen",
        productStok: "Quản lý kho",
        productSetting: "Cài đặt sản phẩm",
        exchangeRecord: "Lịch sử đổi",
        payMethod: "Cài đặt thanh toán",
        callBackWhiteList: "Danh sách callback",
        withdrawMethod: "Cài đặt rút",
        withdrawOrderList: "Quản lý rút",
        payOrderList: "Quản lý nạp",
        bounsReport: "Báo cáo ưu đãi",
        agentBonusStats: "Báo cáo ưu đãi đại lý",
        paymentChannel: "Kênh thanh toán",
        withdrawType: "Phương thức rút",
        vipExchangeMgmt: "Cài đặt VIP",
        vipSetupMgmt: "Cấp VIP",
        vipLogMgmt: "Tra cứu VIP",
        memberMgmt: "Quản lý thành viên",
        memberDtail: "Chi tiết thành viên",
        more: "Thêm",
        analysis: "Phân tích",
        inviteFriend: "Mời bạn bè",
        inviteFriendReport: "Báo cáo mời bạn bè",
        gamePlatReoprt: "Báo cáo game",
        gamePlatReoprtB: "Báo cáo game - B",
        gameCodeReoprt: "Báo cáo game con",
        gameCodeReoprtB: "Báo cáo game con - B",
        betReport: "Báo cáo cược",
        betReportA: "Báo cáo cược",
        betReportB: "Báo cáo cược - B",
        crossDayTransferSettlement: "Bảng Phân Tích Chuyển Kết Toán Liên Ngày",
        dashboardReport: "Bảng tổng hợp",
        withdrawReport: "Báo cáo rút",
        depositReport: "Báo cáo nạp",
        payOrderStat: "Bảng Điều Khiển Nạp Tiền",
        withdrawOrderStat: "Bảng Điều Khiển Rút Tiền",
        rechargeSettlementAnalysis: "Phân tích nạp/rút tiền",
            registrationConversion: "Báo cáo đăng ký và chuyển đổi",
    userRegisterDistribution: "Bảng điều khiển đăng ký người dùng",
    activeUserDistribution: "Bảng điều khiển người dùng hoạt động",
    onlineUserDistribution: "Bảng Điều Khiển Người Dùng Trực Tuyến",
    valueStats: "Báo cáo thống kê giá trị",
    keepStats: "Báo cáo giữ chân nạp tiền",
    betKeepStats: "Báo cáo thống kê giữ chân cược",
    overviewStats: "Báo cáo thống kê tổng quan",
    userAnalysis: "Phân tích người dùng",
        webSiteConfig: "Cấu Hình Tham Số",
        emailConfig: "Cấu hình tài khoản email",
        emailTemplate: "Quản lý mẫu email",
        emailconfig: "Cấu hình tài khoản email",
        emailsendtempconfig: "Quản lý mẫu email",
        seoPageManager: "Quản lý trang SEO",
        payReport: "Báo cáo nạp",
        notifyManage: 'Quản lý thông báo APP',
        autoPushRecord: "Lịch sử đẩy tự động",
        autoPushConfig: "Cấu hình đẩy tự động",
        autoPushStats: "Thống kê đẩy tự động",
        manualPushRecord: "Lịch sử đẩy thủ công",
        manualPushConfig: "Đẩy thủ công theo thời gian thực",
        manualPushReport: "Đẩy số liệu thống kê theo cách thủ công",
        kycconfig: "cấu hình kyc",
        riskWithdrawConfigGroup: "Cấu hình kiểm soát rút tiền",
        riskWithdrawConfigPhp: "Cấu hình tiền tệ PHP",
        riskWithdrawConfigVnd: "Cấu hình tiền tệ VND",
        riskWithdrawConfigCny: "Cấu hình tiền tệ CNY",
        riskWithdrawConfigUsd: "Cấu hình tiền tệ USD",
        riskWithdrawConfigMxn: "Cấu hình tiền tệ MXN",
        paramConfigGroup: "Cấu hình tham số",
        paramAccountAuth: "Tài khoản & Xác thực",
        paramSecurityRisk: "Bảo mật & Rủi ro",
        paramThirdPartyService: "Dịch vụ bên thứ ba",
        paramAppMgmt: "Quản lý App",
        paramBizRule: "Quy tắc nghiệp vụ & Tham số hệ thống",
        paramResourceDisplay: "Quản lý tài nguyên",
        paramReportConfig: "Cấu hình báo cáo giám sát",
        paramRouteStrategy: "Cấu hình chiến lược tuyến game",
        messageNotify: "Tin nhắn & Thông báo",
        payWithdrawConfigGroup: "Cấu hình nạp/rút tiền",
        withdrawBaseConfig: "Cấu hình rút tiền cơ bản",
        withdrawAccountBindConfig: "Cấu hình liên kết tài khoản rút",
        kycConfigGroup: "Cấu hình KYC",
        kycGlobalConfig: "Cấu hình KYC toàn cục",
        kycNormalScene: "Kịch bản KYC người dùng thường",
        kycAgentScene: "Kịch bản KYC đại lý",
        kycFailRule: "Quy tắc xử lý KYC thất bại",
        agentTag: "Nhãn đại lý",
        agentType: "Loại đại lý",
        memberLoginLog: "Lịch sử đăng nhập",
        memberLoginLogReport: "Thông tin cơ bản",
        memberLoginLogSummary: "Báo cáo tổng quan",
        inboxMessage: "Tin nhắn",
        sendInboxMessage: "Gửi tin nhắn",
        luckySpin: "Quản lý Vòng quay May mắn",
        luckySpinTicketMgmt: "Cài đặt Vé tham gia",
        luckySpinGrantTicketLog: "Lịch sử phát vé",
        luckySpinLog: "Lịch sử sử dụng",
        activeMember: "Danh sách thành viên hoạt động",
        depositMemberList: "Danh sách người dùng nạp tiền",
        vipMemberList: "Danh sách thành viên VIP",
        autoInboxMannulConfig: "Gửi tin nhắn thủ công",
        autoInboxMessageConfig: "Cấu hình tự động gửi tin nhắn",
        autoInboxMessage: "Dữ liệu tự động gửi tin nhắn",
        mannuInboxStats: "Thống kê tin nhắn thủ công",
        autoInboxStats: "Thống kê tin nhắn tự động",
        auditReport: "Báo cáo Kiểm duyệt",
        auditSummary: "Báo cáo Tổng quan",
        auditGameType: "Báo cáo Loại Trò Chơi",
        auditBranchGameType: "Báo cáo Loại Trò Chơi Chi Nhánh",
        auditProvider: "Báo cáo Nhà Cung Cấp",
        auditProviderGameType: "Báo cáo Loại Trò Chơi Nhà Cung Cấp",
        auditGameOrder: "Đơn cược",
        auditPlayerCount: "Báo cáo Số Lượng Người Chơi",
        auditPlayerAggregator: "Báo cáo Người Chơi Tổng Hợp",
        auditCloseReportUser: "Danh sách đã tắt báo cáo",
        closeReportUser: "Nhật ký thay đổi tuyến game",
        newsManagement: "Quản lý bài viết",
        newsListMgmt: "Danh sách bài viết",
        newsCategoryMgmt: "Danh mục bài viết",
        newsTagMgmt: "Thẻ bài viết",
        newsInternalLinkMgmt: "Từ khóa liên kết nội bộ",
        newsCategory: "Danh mục bài viết",
        newsTag: "Thẻ bài viết",
        newsArticle: "Danh sách bài viết",
        userLeaderboard: "Xếp hạng người dùng",
        depositLeaderboard: "Bảng xếp hạng nạp tiền",
        withdrawLeaderboard: "Bảng xếp hạng rút tiền",
        promotionLeaderboard: "Bảng xếp hạng ưu đãi",
        winLeaderboard: "Bảng xếp hạng thắng",
        lossLeaderboard: "Bảng xếp hạng thua",
        betLeaderboard: "Bảng xếp hạng đặt cược",
        gameRanking: "Bảng xếp hạng trò chơi",
        leaderboardActivity: "Hoạt động bảng xếp hạng",
        leaderboardActivityActivityList: "Danh sách hoạt động",
        leaderboardActivityBoardRecords: "Bản ghi bảng",
        leaderboardActivityAwardRecords: "Bản ghi phát thưởng",
        importLog: "Quản lý nhật ký nhập",
        inviterList: "Danh sách mời bạn bè",
        jeepneyUserList: "Truy vấn người dùng phân hạch",
        rebateList: "Bản ghi hoàn tiền",
        negativeProfitMember: "Danh sách thành viên lỗ vốn",
        tagMgmt: "Quản lý thẻ",
        manualTag: "Thẻ thủ công",
        autoTag: "Nhãn tự động",
        chickActivity: "Hoạt động check-in",
        chickActivityMgmt: "Cấu hình hoạt động",
        chickActivityReport: "Báo cáo dữ liệu",
        chickActivityUserStats: "Truy vấn trạng thái người dùng",
        jeepneyActivity: "Hoạt động phân tách",
        jeepneyActivityMgmt: "Cấu hình hoạt động phân tách",
        jeepneyBlockRewardMgmt: "Cài đặt đường đua và phần thưởng",
        jeepneySettlementMgmt: "Cài đặt thanh toán",
        jeepneyFunnelAnalysis: "Phân Tích Phễu Jeepney",
        treasureBox: "Quản lý Rương",
        treasureBoxMgmt: "Quản lý Rương",
        treasureBoxConfig: "Cài đặt Rương",
        treasureBoxStats: "Thống kê Rương",
        treasureBoxRecords: "Lịch sử Phân phối Rương",
        treasureBoxRecord: "Lịch sử Phân phối Rương",
        report: "Báo cáo tài chính",
    },
    // Tên nút: key là buttonCode trung tính ngôn ngữ (platformButton.buttonCode).
    // Khi không có key, trang sẽ hiển thị buttonName lưu trong DB (nút do vận hành tự tạo).
    sysButton: {
        "accountInfo-BankCardStatus": "Chi tiết thành viên - Thông tin tài khoản - Bật/Tắt thẻ ngân hàng",
        "accountInfo-BankCardUnbind": "Chi tiết thành viên - Thông tin tài khoản - Liên kết/Hủy liên kết thẻ ngân hàng",
        "accountInfo-FlowManualAdjust": "Chi tiết thành viên - Thông tin tài khoản - Điều chỉnh doanh thu cược thủ công",
        "accountInfo-WalletManualAdjust": "Chi tiết thành viên - Thông tin tài khoản - Điều chỉnh ví thủ công",
        "accountInfo-WalletStatus": "Chi tiết thành viên - Thông tin tài khoản - Bật/Tắt ví",
        "accountInfo-WalletTakeBack": "Chi tiết thành viên - Thông tin tài khoản - Thu hồi ví",
        "accountInfo-WalletUnbind": "Chi tiết thành viên - Thông tin tài khoản - Liên kết/Hủy liên kết ví",
        "accountInfo-manualAdjustPoint": "Chi tiết thành viên - Điểm tài khoản - Điều chỉnh điểm thủ công",
        adminRiskUnLock: "Quản trị viên mở khóa kiểm soát rủi ro rút tiền",
        adminRiskView: "Quản trị viên tìm kiếm kiểm soát rủi ro rút tiền",
        "batchDistribution-Participation": "Phát hàng loạt - Vé tham gia",
        "batchDistribution-cash": "Phát hàng loạt - Tiền mặt",
        "batchDistribution-integral": "Phát hàng loạt - Điểm",
        "chargeOrderManager-comfirmOrder": "Quản lý đơn nạp tiền - Xác nhận đơn",
        "chargeOrderManager-export": "Quản lý đơn nạp tiền - Xuất",
        "exchangeRecord-export": "Lịch sử đổi thưởng - Xuất",
        "manualBalance-export": "Xuất lịch sử điều chỉnh số dư thành viên",
        "manualBalanceHistory-export": "Xuất",
        "memberInfo-AgentName": "Chi tiết thành viên - Thông tin cơ bản - Đại lý cấp trên",
        "memberInfo-Email": "Chi tiết thành viên - Thông tin cơ bản - Email",
        "memberInfo-Identity": "Chi tiết thành viên - Thông tin cơ bản - Thông tin danh tính",
        "memberInfo-Phone": "Chi tiết thành viên - Thông tin cơ bản - Số điện thoại",
        "memberInfo-RegulatoryReportClose": "Chi tiết thành viên - Tắt báo cáo dữ liệu",
        "memberInfo-RegulatoryReportTab": "Chi tiết thành viên - Tab trạng thái tuyến trò chơi",
        "memberInfo-Remark": "Chi tiết thành viên - Thông tin cơ bản - Ghi chú",
        "memberInfo-ResetPassword": "Chi tiết thành viên - Thông tin cơ bản - Đặt lại mật khẩu đăng nhập",
        "memberInfo-ResetWithdrawPassword": "Chi tiết thành viên - Thông tin cơ bản - Đặt lại mật khẩu rút tiền",
        "memberInfo-WithdrawLimit": "Chi tiết thành viên - Thông tin cơ bản - Hạn mức rút tiền",
        "memberWithdrawLimit-edit": "Hạn mức rút tiền hàng ngày của thành viên - Sửa",
        "memberInfo-RiskLevel": "Chi tiết thành viên - Thông tin cơ bản - Kiểm soát rủi ro",
        "memberInfo-UserTypeSetting": "Cài đặt loại người dùng",
        "memberInfo-View-Phone": "Chi tiết thành viên - Thông tin cơ bản - Xem số điện thoại",
        "memberInfo-export": "Xuất dữ liệu thành viên",
        "memberInfo-kyc-edit": "KYC rút tiền - Sửa",
        "memberInfo-upload": "Tải lên dữ liệu thành viên",
        "memberchurn-export": "Danh sách người dùng rời bỏ - Xuất",
        "memberchurn-query": "Danh sách người dùng rời bỏ - Truy vấn",
        "memberkycinfo-batchSetFail": "Lịch sử yêu cầu xác minh KYC - Đặt hàng loạt là thất bại",
        "memberkycinfo-batchSetSuccess": "Lịch sử yêu cầu xác minh KYC - Đặt hàng loạt là thành công",
        "memberkycinfo-docmentData": "Sửa thông tin KYC - Giấy tờ",
        "memberkycinfo-historicalData": "Lịch sử yêu cầu xác minh KYC - Dữ liệu lịch sử",
        "memberkycinfo-idCard": "Lịch sử yêu cầu xác minh KYC - Giấy tờ tùy thân",
        "memberkycinfo-setFail": "Lịch sử yêu cầu xác minh KYC - Đặt là thất bại",
        "memberkycinfo-setSuccess": "Lịch sử yêu cầu xác minh KYC - Đặt là thành công",
        "membernorecharge-export": "Danh sách đăng ký chưa nạp - Xuất",
        "membernorecharge-query": "Danh sách đăng ký chưa nạp - Truy vấn",
        "newsArticle-add": "Bài viết tin tức - Thêm bài viết",
        "newsArticle-approve": "Bài viết tin tức - Phê duyệt",
        "newsArticle-delete": "Bài viết tin tức - Xóa",
        "newsArticle-edit": "Bài viết tin tức - Sửa",
        "newsArticle-reject": "Bài viết tin tức - Từ chối",
        "newsArticle-seo-edit": "Bài viết tin tức - Sửa SEO",
        opUserAdjustQuota: "Quản lý hạn mức",
        opUserDelete: "Xóa",
        opUserDisable: "Vô hiệu hóa",
        opUserEdit: "Sửa",
        opUserModifyRole: "Sửa vai trò",
        opUserResetGoogleAuth: "Đặt lại mã Google Authenticator",
        opUserResetLoginPassword: "Đặt lại mật khẩu đăng nhập",
        "email-log-export": "Nhật ký gửi email - Xuất",
        "sms-log-export": "Nhật ký SMS - Xuất danh sách thất bại",
        "withdrawOrderList-adminUnLock": "Quản lý đơn rút tiền - Quản trị viên mở khóa",
        "withdrawOrderList-confirmWithdrawal": "Quản lý đơn rút tiền - Xác nhận chi trả",
        "withdrawOrderList-export": "Quản lý đơn rút tiền - Xuất",
        "withdrawOrderList-refusedWithdrawal": "Quản lý đơn rút tiền - Từ chối rút tiền",
        "withdrawOrderList-reject": "Quản lý đơn rút tiền - Từ chối",
        "withdrawOrderList-replaceWithdrawal": "Quản lý đơn rút tiền - Chi trả qua bên thứ ba"
    },
    menu: {
        add: "Thêm",
        edit: "Chỉnh sửa",
        menu: "Menu",
        parentMenu: "Nút Menu Cha",
        selectParentMenu: "Chọn Nút Menu Cha",
        menuLevel: "Cấp Menu",
        selectMenuLevel: "Vui Lòng Chọn Cấp Menu",
        menuCode: "Mã Menu",
        menuName: "Tên Menu",
        isLeaf: "Có Phải Nút Lá",
        yes: "Có",
        no: "Không",
        menuUrl: "Địa Chỉ URL Backend",
        enterMenuUrl: "Vui Lòng Nhập Địa Chỉ URL Backend",
        menuOrder: "Thứ Tự Menu"
    },
    tagView: {
        closeCurrent: "Đóng tab hiện tại",
        closeOthers: "Đóng các tab khác",
        closeAll: "Đóng tất cả",
        home: "Trang chủ"
    },
    avatar: {
        personalCenter: "Trung tâm cá nhân",
        changePassword: "Thay đổi mật khẩu",
        logout: "Đăng xuất"
    }
}
